import { createAction, props } from '@ngrx/store';

import { SortDirection } from '../constants';
import { PropertyViewConfig } from '../services/feed-settings.service';

export const setWorkspaceFilterString = createAction(
  '[Workspace] Set Workspace Filter String',
  props<{ filterString: string }>(),
);

export const setWorkspaceSortingField = createAction(
  '[Workspace] Set Workspace Sorting Field',
  props<{ sortingField: string }>(),
);

export const setWorkspaceSortingDirection = createAction(
  '[Workspace] Set Workspace Sorting Direction',
  props<{ sortingDirection: SortDirection }>(),
);

export const setWorkspaceTab = createAction(
  '[Workspace] Set Workspace Tab',
  props<{ tab: 'active' | 'archived' | 'deleted' }>(),
);

export const setWorkspaceObjectsLifeCycle = createAction(
  '[Workspace] Set Workspace Objects Lifecycle',
  props<{ workspaceId: string; workspaceObjectsLifeCycle: number }>(),
);

export const fetchWorkspaceViewConfig = createAction(
  '[Workspace] Fetch Workspace View Config',
  props<{ userId: string }>(),
);

export const fetchWorkspaceViewConfigSuccess = createAction(
  '[Workspace] Fetch Workspace View Config Success',
  props<{
    defaultWorkspaceConfig: PropertyViewConfig[];
    workspaceConfig: PropertyViewConfig[];
  }>(),
);

export const fetchWorkspaceViewConfigFail = createAction(
  '[Workspace] Fetch Workspace View Config Fail',
  props<{ error: string }>(),
);

export const toggleWorkspaceViewConfigOption = createAction(
  '[Workspace] Toggle Workspace View Config Option',
  props<{ optionName: string }>(),
);

export const toggleWorkspaceViewConfigOptionSuccess = createAction(
  '[Workspace] Toggle Workspace View Config Option Success',
);

export const toggleWorkspaceViewConfigOptionFail = createAction(
  '[Workspace] Toggle Workspace View Config Option Fail',
  props<{ error: string }>(),
);
